<template>
  <div
    id="content-wrapper"
    class="is-wrapper"
    :class="{
      'landscape': isLandscape,
      'landscape-sidebar': isLandscapeSidebar,
      'portrait': !isLandscape && !isLandscapeSidebar,
      'newsletter': isNewsletter
    }"
    @input="onInput"
    ref="ContentBox"
  ></div>
</template>

<script>
import ContentBox from "@innovastudio/contentbox";
import '@innovastudio/contentbuilder/public/contentbuilder/contentbuilder.css';
import '@innovastudio/contentbox/public/contentbox/contentbox.css';

import '../../../assets/contentbox/css/content.scss';
import '../../../assets/contentbox/css/box-flex.css';
/*import '../../../assets/contentbox/css/type-poppins.css';*/
import '../../../assets/contentbox/css/ioni.css';

import {ContentTypes} from "@/enums/ContentTypes";
import {uploadImage, optimizePhotos} from "@/utils/upload-image";
import {v4 as uuidv4} from "uuid";
import {CustomContentMixin} from "@/mixins/CustomContent";
import {ContentCustomWidgetsTypes} from "@/enums/ContentCustomWidgetsTypes";
import {getRegionEnv} from "@/utils/functionsRegionEnv";

export default {
  name: "ContentCreator",
  mixins: [CustomContentMixin],
  data() {
    return {
      builder: null,
      baseEndpoint: null,
    }
  },
  props: {
    currentContent: {
      default: true
    },
    isLandscape: {
      type: Boolean
    },
    isLandscapeSidebar: {
      type: Boolean
    },
    isCanvas: {
      type: Boolean
    }
  },
  computed: {
    facilityId() {
      return this.$store.state.authModule.currentFacility;
    },
    isNewsletter() {
      return this.currentContent?.type === ContentTypes.PrintableNewsletter;
    },
  },
  methods: {
    onInput() {
      this.$emit("disableSaving");
    },
    initContentBuilder() {
      this.builder = new ContentBox({
        wrapper: '.is-wrapper',
        canvas: this.isCanvas ? true : false,

        imageSelect: '/contentbox/files/files.html',
        videoSelect: '/contentbox/files/files.html',
        audioSelect: '/contentbox/files/files.html',
        fileSelect: '/contentbox/files/files.html',
        mediaSelect: '/contentbox/files/files.html',

        listFilesUrl: `${this.baseEndpoint}/listfiles/${this.facilityId}`,
        listFoldersUrl: `${this.baseEndpoint}/listfolders/${this.facilityId}`,

        // To enable AI Assistant
        sendCommandUrl: `${this.baseEndpoint}/sendcommand`,
        startAIAssistant: false,
        speechRecognitionLang: 'en-US',
        triggerWords: {
          send: ['send', 'okay', 'ok', 'execute', 'run'],
          abort: ['abort', 'cancel'],
          clear: ['clear', 'erase']
        },

        controlPanel: true,
        screenMode: 'desktop',
        navbar: true,
        iframeSrc: '/contentbox/blank.html',

        assetFolderTree: true,
        panelReverse: true, // To reverse the file manager & AI image generation panel.
        filesOnly: true, // To show only the file manager (hiding the AI image generation panel).
        filePicker: true, // Used as a file picker.
        refreshButton: true,
        assetPanelReverse: false,
        assetFilesOnly: false,
        assetRefreshButton: false,
        assetAllowedFileTypes: [
          'image/jpeg',
          'image/png',
          'image/gif',
          'image/webp',
          'image/bmp',
          'image/tiff',
          'image/svg+xml',
          'image/vnd.adobe.photoshop',
          'video/mp4',
          'video/quicktime',
          'audio/mpeg',
          'application/json',
          'application/font',
          'application/pdf',
          'application/zip',
          'application/x-rar-compressed',
          'application/msword',
          'application/rtf',
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          'application/vnd.openxmlformats-officedocument.presentationml.presentation',
          'text/csv',
          'text/markdown',
          'text/plain',
          'text/css',
          'text/javascript',
          'text/html',
        ],
        assetShowRelativeTime: true,
        assetLocale: 'default',
        assetDateShortOptions: {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
        },
        assetDateLongOptions: {
          weekday: 'short',
          year: 'numeric',
          month: 'short',
          day: 'numeric',
          hour: 'numeric',
          minute: 'numeric',
        },
        assetPanelFullScreen: true,

        plugins: [],
        disableConfig: true,

        clearPreferences: true,
        zoom: 1,
        snippetUrl: 'https://firebasestorage.googleapis.com/v0/b/reshub-test.appspot.com/o/contentbox%2Fsnippets-prod-v11.js?alt=media&token=a383cd53-5e93-4362-9364-e08ada3b6cf8',
        snippetPath: 'https://firebasestorage.googleapis.com/v0/b/reshub-test.appspot.com/o/contentbox%2Fpreview%2F',
        snippetPathReplace: ['assets/', 'https://firebasestorage.googleapis.com/v0/b/reshub-test.appspot.com/o/contentbox%2Fpreview%2F'],
        contentStylePath: 'https://demo.innovastudio.com/assets/styles/',
        featuredCategories: [
          {id: 1, designId: 1, name: 'Basic'},
          {id: 1, designId: 2, name: 'Hero'},
          {id: 2, designId: 2, name: 'Article'},
          {id: 3, designId: 2, name: 'Showcase'}
        ],
        templates: [
          {
            url: 'https://firebasestorage.googleapis.com/v0/b/reshub-test.appspot.com/o/contentbox%2Ftemplates-prod.js?alt=media&token=94c35b5f-897f-49d6-baa0-b7ccbefcb0a1',
            path: 'https://firebasestorage.googleapis.com/v0/b/reshub-test.appspot.com/o/contentbox%2Fpreview%2F',
            pathReplace: []
          },
          {
            url: 'https://firebasestorage.googleapis.com/v0/b/reshub-test.appspot.com/o/contentbox%2Ftemplates-extra-blocks-prod2.js?alt=media&token=fc37328c-d30b-409c-9970-bb2be5d59caa',
            path: 'https://firebasestorage.googleapis.com/v0/b/reshub-test.appspot.com/o/contentbox%2Fpreview-extra-blocks%2F',
            pathReplace: []
          },
          {
            url: 'https://demo.innovastudio.com/assets/animated/templates.js',
            path: 'https://demo.innovastudio.com/assets/animated/',
            pathReplace: []
          },
        ],
        assetPath: 'https://demo.innovastudio.com/assets/',
        templateThumbnailSize: 'small',
        fontAssetPath: 'https://demo.innovastudio.com/assets/fonts/',
        onUploadCoverImage: async (e) => {
          const path = `contentbox/assets/${this.facilityId}/${uuidv4()}`;
          const file = await optimizePhotos(e.target.files[0], 'background-image');

          await uploadImage({
            path,
            file,
            onStart: () => {
              console.log("Loading")
            },
            onComplete: async storage => {
              const url = await storage.snapshot.ref.getDownloadURL();
              this.builder.boxImage(url);
              await this.getExistsPhotos();
              const div = document.querySelector(".imageselect iframe");
              div.setAttribute("src", "about:blank");
            }
          })
        },
        onChange: () => {
          if(this.currentContent.type === ContentTypes.PrintableNewsletter) {
            this.changeContentHtml();
          }

          if(this.builder.html().includes("example.png")) {
            const content = document.getElementById("content");
            const getAllImages = content.getElementsByTagName('img');

            for(let i = 0; i < getAllImages.length; i++) {
              if(getAllImages[i].src.includes("example.png")) {
                getAllImages[i].src = `${getAllImages[i].src}?alt=media&token=56cc5a69-4c16-4aa1-bae3-fcf6f1fc387a`;
              }
            }
          }

          const data = {
            html: this.builder.html(),
            mainCss: this.builder.mainCss(),
            sectionCss: this.builder.sectionCss(),
          }
          this.getBuilderHtml(data);
        },
      });

      this.builder.addButton({
        'pos': 2,
        'title': 'Undo',
        'html': '<svg class="is-icon-flex" style="width: 14px; height: 14px; fill: rgb(0, 0, 0);"><use xlink:href="#ion-ios-undo"></use></svg>', // icon
        'onClick': () => {
          this.builder.undo();
        }
      });

      this.builder.addButton({
        'pos': 3,
        'title': 'Redo',
        'html': '<svg class="is-icon-flex" style="width: 14px; height: 14px; fill: rgb(0, 0, 0);"><use xlink:href="#ion-ios-redo"></use></svg>', // icon
        'onClick': () => {
          this.builder.redo();
        }
      });

      this.builder.addButton({
        'pos': 4,
        'title': 'Settings',
        'html': '<svg class="is-icon-flex" style="width:15px;height:15px;"><use xlink:href="#icon-settings"></use></svg>', // icon
        'onClick': () => {
          this.builder.openSettings();
        }
      });

      this.builder.addButton({
        'pos': 5,
        'title': 'AI Assistant',
        'html': '<svg class="is-icon-flex" style="width:16px;height:16px;"><use xlink:href="#icon-message"></use></svg>',
        'onClick': (e)=>{
          this.builder.openAIAssistant();
        }
      });

      setTimeout(() => {
        this.changeContentWrapper(this.isLandscape, this.isNewsletter, this.isLandscapeSidebar);
      }, 2000)
    },
    generateBaseEndpoint() {
      const env = getRegionEnv();
      this.baseEndpoint = `${env}/externalClientsApi`;
    },
    getBuilderHtml(data) {
      this.$emit('getBuilderHtml', data)
    },
    setContent() {
      if (this.currentContent?.html) {
        this.builder.loadHtml(this.currentContent?.html);
        this.builder.loadStyles(this.currentContent.mainCss, this.currentContent.sectionCss);
      } else {
        this.builder.loadStyles("", "");
        this.builder.loadHtml("");
      }

      if(this.isCanvas) {
        this.builder.featuredCategories = [
          {id: 1, designId: 1, name: 'Basic'},
        ];

        this.builder.templates = [
          {
            url: 'https://firebasestorage.googleapis.com/v0/b/reshub-test.appspot.com/o/contentbox%2Ftemplates-canva-prod.js?alt=media&token=6377b3ed-ebd4-4ba1-9ce9-7a4d5045e7c8',
            path: 'https://firebasestorage.googleapis.com/v0/b/reshub-test.appspot.com/o/contentbox%2Fpreview%2F',
            pathReplace: []
          }
        ];
      }
    },
    async changeContentHtml() {
      let stringHtml = this.builder.html();
      const CustomWidgetsTypes = Object.values(ContentCustomWidgetsTypes);

      if(!CustomWidgetsTypes.some(x => stringHtml.includes(`id="${x}"`))) {
        return;
      }

      const Handlebars = require('handlebars');
      await this.getData(stringHtml);

      if(stringHtml.includes(`id="${ContentCustomWidgetsTypes.UpcomingEvents}"`)) {
        stringHtml = stringHtml.replace(`id="${ContentCustomWidgetsTypes.UpcomingEvents}"`, "");
      }

      if(stringHtml.includes(`id="${ContentCustomWidgetsTypes.Menu}"`)) {
        stringHtml = stringHtml.replace(`id="${ContentCustomWidgetsTypes.Menu}"`, "");
      }

      if(stringHtml.includes(`id="${ContentCustomWidgetsTypes.Breakfast}"`)) {
        stringHtml = stringHtml.replace(`id="${ContentCustomWidgetsTypes.Breakfast}"`, "");
      }

      if(stringHtml.includes(`id="${ContentCustomWidgetsTypes.Lunch}"`)) {
        stringHtml = stringHtml.replace(`id="${ContentCustomWidgetsTypes.Lunch}"`, "");
      }

      if(stringHtml.includes(`id="${ContentCustomWidgetsTypes.Dinner}"`)) {
        stringHtml = stringHtml.replace(`id="${ContentCustomWidgetsTypes.Dinner}"`, "");
      }

      if(stringHtml.includes(`id="${ContentCustomWidgetsTypes.WeeklyCalendar}"`)) {
        stringHtml = stringHtml.replace(`id="${ContentCustomWidgetsTypes.WeeklyCalendar}"`, "");
      }

      if(stringHtml.includes(`id="${ContentCustomWidgetsTypes.MonthlyCalendar}"`)) {
        stringHtml = stringHtml.replace(`id="${ContentCustomWidgetsTypes.MonthlyCalendar}"`, "");
      }

      if(stringHtml.includes(`id="${ContentCustomWidgetsTypes.DailyCalendar}"`)) {
        stringHtml = stringHtml.replace(`id="${ContentCustomWidgetsTypes.DailyCalendar}"`, "");
      }

      if(stringHtml.includes(`id="${ContentCustomWidgetsTypes.ThisWeeksBirthday}"`)) {
        stringHtml = stringHtml.replace(`id="${ContentCustomWidgetsTypes.ThisWeeksBirthday}"`, "");
      }

      const compiledTemplate = Handlebars.compile(stringHtml);
      const generatedHtml = compiledTemplate(this.dataCustomContent);

      this.builder.loadHtml(generatedHtml);

      const data = {
        html: this.builder.html(),
        mainCss: this.builder.mainCss(),
        sectionCss: this.builder.sectionCss(),
      }

      this.$emit('getBuilderHtml', data);
    },
    changeContentWrapper(value, isNewsletter, isLandscapeSidebar) {
      const iframe = document.getElementById('ifrBuilder');
      const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
      const iframeBlock = iframeDocument.getElementsByClassName('is-wrapper')[0];

      if(value) {
        iframeBlock.classList.remove('portrait');
        iframeBlock.classList.add('landscape');
      } else {
        iframeBlock.classList.remove('landscape');
        iframeBlock.classList.add('portrait');
      }

      if(isNewsletter) {
        iframeBlock.classList.add('newsletter');
      } else {
        iframeBlock.classList.remove('newsletter');
      }

      if(isLandscapeSidebar) {
        iframeBlock.classList.add('landscape-sidebar');
        iframeBlock.classList.remove('portrait');
      } else {
        iframeBlock.classList.remove('landscape-sidebar');
      }
    }
  },
  watch: {
    currentContent() {
      this.setContent();

      setTimeout(() => {
        this.$emit("isBuilderReady", true);
      }, 5000);
    },
    isLandscape(value) {
      this.changeContentWrapper(value, this.isNewsletter, this.isLandscapeSidebar)
    },
    isLandscapeSidebar() {
      this.changeContentWrapper(this.isLandscape, this.isNewsletter, this.isLandscapeSidebar)
    }
  },
  created() {
    this.generateBaseEndpoint();
  },
  mounted() {
    this.initContentBuilder();
    this.$emit("getBuilder", this.builder);
    this.setContent();

    setTimeout(() => {
      this.$emit("isBuilderReady", true);
    }, 5000);
  },
}
</script>
